<script lang='ts' setup>
const refreshUser = useState<boolean>('refreshUser', () => false);
const { loggedIn, fetch: refreshSession } = useUserSession();

const sidebarOpen = ref(false);
const sidebarCollapsed = ref(false);

const toggleSidebar = () => {
	sidebarOpen.value = !sidebarOpen.value;
};

const toggleSidebarCollapse = () => {
	sidebarCollapsed.value = !sidebarCollapsed.value;
};

const sidebarNotCollapsed = () => {
	sidebarCollapsed.value = false;
};

provide('sidebarToggle', toggleSidebar);
provide('sidebarCollapse', toggleSidebarCollapse);
provide('sidebarNotCollapsed', sidebarNotCollapsed);

const navType = computed(() => {
	return loggedIn.value ? 'website' : 'auth';
});

watch(refreshUser, () => {
	if (refreshUser.value) {
		refreshSession();
		refreshUser.value = false;
	}
});
</script>

<template>
	<Navbar :nav-type="navType" :show-sidebar-toggle="true" />
	<div class="flex h-full min-h-screen items-stretch py-[var(--ui-header-height)]">
		<UDrawer direction="left" :handle="false" inset v-model:open="sidebarOpen" :dismissible="true" class="md:hidden">
			<template #content>
				<AppSidebar :collapsed="false" />
			</template>
		</UDrawer>
		<div class="shadow-xl z-40 hidden md:block transition-all duration-300 ease-in-out" v-if="loggedIn"
			:class="{ 'w-64': !sidebarCollapsed, 'w-14': sidebarCollapsed }">
			<AppSidebar :collapsed="sidebarCollapsed" />
		</div>
		<div class="flex-1">
			<EmailVerificationNotification />
			<SubscriptionNotification />
			<slot />
		</div>
	</div>
	<Footer />
</template>
